import React, { useCallback, useEffect, useRef, useState } from 'react';
import icCloseCircle from 'Assets/img/ic_close_circle_24_strong@2x.png';
import icShare from 'Assets/img/ic_share_16_strong@2x.png';
import icInfo from 'Assets/img/ic_info_16_basic@2x.png';
import IntlMessages from 'Util/IntlMessages';
import BasicButton from 'Components/Button/BasicButton';
import { useError } from 'Api/hooks/useError';
import { useIntl } from 'react-intl';
import { uploadFileWithoutAuth } from 'Api/endpoints/Auth';
import { getFileName, getFileNameArrayWithExtension, isImage } from 'Util/DataUtils';
import { getExtensionImages2 } from 'Util/Extension2';
import { getFileSize } from 'Util/FileUtils';

// todo 로딩
const UploadBusinessRegistrationView = ({ imageBusinessRegistration, onChange }) => {
  const inputFileRef = useRef(null);
  const { showErrorPopup } = useError();
  const { formatMessage } = useIntl();
  const [fileSize, setFileSize] = useState(null);

  const _getFileSize = useCallback(async () => {
    const size = await getFileSize(imageBusinessRegistration);
    setFileSize(size);
  }, [imageBusinessRegistration]);

  useEffect(() => {
    _getFileSize();
  }, [_getFileSize]);

  const sendFile = async file => {
    try {
      const maxFileSize = 10 * 1024 * 1024;
      if (file.size > maxFileSize) {
        showErrorPopup({
          text: formatMessage({ id: 'upload.business.registration.view.hint' }),
        });
        return;
      }
      const result = await uploadFileWithoutAuth(file);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      onChange({ target: { name: 'imageBusinessRegistration', value: result.data.image.origin_path } });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className='upload-business-registration-view'>
      <div className='upload-business-registration-view-title'>
        <div className='upload-business-registration-view-title-text'>
          <IntlMessages id='upload.business.registration.view.title' />
        </div>
        <div className='upload-business-registration-view-title-content'>
          <BasicButton type='tertiary' textId='upload.business.registration.view.upload.text' style={{ width: '100%' }} onClick={() => inputFileRef.current.click()}>
            <img src={icShare} alt='icShare' style={{ width: 16, height: 16 }} />
          </BasicButton>
          <input type='file' ref={inputFileRef} onChange={e => sendFile(e.target.files[0])} style={{ display: 'none' }} />
          <div className='upload-business-registration-view-title-content-hint'>
            <img src={icInfo} alt='info' style={{ width: 16, height: 16 }} />
            <div className='upload-business-registration-view-title-content-hint-text'>
              <IntlMessages id='upload.business.registration.view.hint' />
            </div>
          </div>
        </div>
      </div>
      {imageBusinessRegistration && (
        <div className='upload-business-registration-view-content'>
          <div className='upload-business-registration-view-content-left'>
            <div className='upload-business-registration-view-content-image'>
              {isImage(imageBusinessRegistration) ? (
                <img src={imageBusinessRegistration} alt='image' style={{ width: 40, height: 40, objectFit: 'cover' }} />
              ) : (
                <img src={getExtensionImages2(getFileNameArrayWithExtension(imageBusinessRegistration)[1])} alt='image' style={{ width: '20px', height: '20px' }} />
              )}
            </div>
            <div className='upload-business-registration-view-content-info'>
              <div className='upload-business-registration-view-content-info-name'>{getFileName(imageBusinessRegistration)}</div>
              <div className='upload-business-registration-view-content-info-size'>{fileSize}</div>
            </div>
          </div>
          <div className='upload-business-registration-view-content-right'>
            <img
              className='cursor-pointer no-drag'
              src={icCloseCircle}
              alt='close'
              style={{ width: 24, height: 24 }}
              onClick={() => onChange({ target: { name: 'imageBusinessRegistration', value: '' } })}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadBusinessRegistrationView;
